import React, { useState } from 'react';

const EmployerSignup = () => {
    const [formData, setFormData] = useState({
        organizationName: '',
        contactName: '',
        jobTitle: '',
        tenure: '',
        username: '',
        password: '',
        industry: '',
        otherIndustry: '',
    });

    const industries = [
        'Technology',
        'Finance',
        'Healthcare',
        'Retail',
        'Manufacturing',
        'Education',
        'Consulting',
        'Real Estate',
        'Marketing & Advertising',
        'Other',
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value,
            ...(name === 'industry' && value !== 'Other' ? { otherIndustry: '' } : {}) // Reset 'otherIndustry' if a predefined industry is selected
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate required fields
        if (!formData.organizationName || !formData.contactName || !formData.jobTitle || !formData.tenure || !formData.username || !formData.password || !formData.industry) {
            alert('All fields are required.');
            return;
        }

        const finalIndustry = formData.industry === 'Other' ? formData.otherIndustry : formData.industry;

        try {
            const response = await fetch('http://127.0.0.1:5000/employers/signup', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ...formData, industry: finalIndustry }),
            });

            if (response.ok) {
                const result = await response.json();
                alert(result.message);
                setFormData({
                    organizationName: '',
                    contactName: '',
                    jobTitle: '',
                    tenure: '',
                    username: '',
                    password: '',
                    industry: '',
                    otherIndustry: '',
                });
            } else {
                const error = await response.json();
                alert(`Error: ${error.error}`);
            }
        } catch (err) {
            console.error('Error submitting the form:', err);
            alert('Failed to submit the form. Please try again.');
        }
    };

    return (
        <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
            <h2>Employer Sign-Up</h2>
            <p>Discover how SciCruit can help streamline your hiring process:</p>
            <ul style={{ textAlign: 'left', margin: '20px 0' }}>
                <li>An AI-optimized approach to implement a scientific recruiting process.</li>
                <li>Comprehensive assessments powered by adaptive algorithms tailored to your organization's needs.</li>
                <li>Save time and resources while finding the top talent; let our platform tell you who the strongest candidates are.</li>
            </ul>
            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '15px' }}>
                    <label>Organization Name:</label>
                    <input
                        type="text"
                        name="organizationName"
                        value={formData.organizationName}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Contact Name:</label>
                    <input
                        type="text"
                        name="contactName"
                        value={formData.contactName}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Job Title:</label>
                    <input
                        type="text"
                        name="jobTitle"
                        value={formData.jobTitle}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Industry:</label>
                    <select
                        name="industry"
                        value={formData.industry}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    >
                        <option value="">-- Select Industry --</option>
                        {industries.map((industry, index) => (
                            <option key={index} value={industry}>
                                {industry}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Show manual input if "Other" is selected */}
                {formData.industry === 'Other' && (
                    <div style={{ marginBottom: '15px' }}>
                        <label>Specify Industry:</label>
                        <input
                            type="text"
                            name="otherIndustry"
                            value={formData.otherIndustry}
                            onChange={handleChange}
                            required={formData.industry === 'Other'}
                            style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                        />
                    </div>
                )}

                <div style={{ marginBottom: '15px' }}>
                    <label>Tenure in Organization:</label>
                    <input
                        type="text"
                        name="tenure"
                        value={formData.tenure}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Username:</label>
                    <input
                        type="text"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>Password:</label>
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        style={{ width: '100%', padding: '10px', marginTop: '5px' }}
                    />
                </div>
                <button
                    type="submit"
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#007BFF',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Sign Up
                </button>
            </form>
        </div>
    );
};

export default EmployerSignup;

